export default {
  pageTitle: 'Transactions',

  filters: {
    title: 'Filters',
    dateRange: 'Charge / Invoice Date Range',
    transactionType: 'Type',
    all: 'All',
    ach: 'Subscription ACH',
    invoice: 'Invoice',
    promotion: 'Promo',
    credit: 'Subscription Credit Card',
    clearFilters: 'Clear All Filters'
  },
  transactionsList: {
    title: 'Transactions List',
    currentTotalBalance: 'Current Total Balance',
    availableCredit: 'Available Credit',
    creditTooltip: '',
    exportBtn: 'Export',
    exportCSV: 'Export CSV',
    exportPDF: 'Export PDF',
    dismiss: 'Dismiss',
    noContentHeader: 'No Transactions',
    noContentMsg: 'There are no transactions to show',
    noContentMsgWithType: 'There are no transactions of %type% to show',
    modal: {
      exportOptionsTitle: 'Exporting Options',
      exportOptionsContent: 'Export a report for %startDate% to %endDate%',
      exportOptionsContentPDF: 'Export a PDF with letterhead for your physical records',
      exportOptionsContentCSV: 'Export a CSV to import raw data into other tools or worksheets',
      exporInProgressTitle: 'Export In Progress',
      exporInProgressContent: 'Your report is being created, due to the size this may take up to %minutes% minutes. We will send an email to %email% when it is ready.',
      exporInProgressContent2: 'You will be able to download the file at<br> <a href="%downloadLink%">%downloadLink%</a><br> when the file is ready.'
    }
  },
  table: {
    date: 'Charge / Invoice Date',
    description: 'Description',
    type: 'Type',
    amount: 'Amount',
    balance: 'Balance',
    paymentFor: 'Payment for #%id%',
    paymentFailed: 'Payment declined for %cardType% ****%lastFourDigits%',
    invoicePaymentFailed: 'Payment failed for Invoice #%id%',
    typePayment: '%type% Payment',
  },
  chargeTypes: {
    credit_card: 'Charge',
    invoice: 'Invoice',
    ach: 'Charge',
    charge: 'Charge',
    promo: 'Promo Code',
    credit: 'Credit',
    debit: 'Debit'
  },
  chargeSummary: {
    details: 'From %fromDate% to %toDate%',
    dueDate: 'Due on: %dueDate%',
    table: {
      date: 'Aprv. Date',
      requestorName: 'User Name',
      wonoloerName: 'Wonoloer Name',
      jobId: 'Job ID',
      adjustments: 'Adjustments',
      details: 'Details',
      wonoloerPay: 'Wonoloer Pay',
      serviceCharge: 'Service Charge',
      totalCost: 'Total Cost',
      description: 'Description'
    }
  },
  chargeStatuses: {
    payment: 'payment'
  }
};
